import {
  buildRichtextHtmlMap,
  mergeDesignRichtextFields,
  normalizeCampaignEmailParams
} from 'features/EmailEditor/campaignEmailCustomizationHelpers'
import { buildEditorTemplateVariables } from 'features/EmailEditor/emailImagePlaceholders'
import { getTemplate, resolveEditorTemplateKey } from 'features/EmailEditor/templates'
import {
  extractPreviewBodyHtml,
  extractSocialMediaUrls,
  generateSocialMediaLinksHtml,
  getHtmlFromMjml,
  mergeNotificationEmailPayload,
  normalizeEmailFooterFields,
  replaceTagsWithPreviewContent,
  resolveSocialFooterTheme,
  resolveStoredShellTemplateKey
} from 'features/EmailEditor/utils'

export function buildInviteEmailDesignPreviewHtml(emailData, userName = '', brandLogoUrl = '') {
  if (!emailData) {
    return ''
  }

  const shellTemplateKey =
    resolveStoredShellTemplateKey(emailData.emailParams) || emailData.shellTemplateKey
  const resolvedShellKey = resolveEditorTemplateKey(shellTemplateKey)
  const currentTemplate = getTemplate(resolvedShellKey)
  const resolvedBrandLogoUrl =
    brandLogoUrl ||
    emailData.globalParams?.logoUrl ||
    emailData.globalParams?.LogoUrl ||
    emailData.emailParams?.logoUrl ||
    ''

  const emailState = mergeNotificationEmailPayload(
    currentTemplate.params,
    {
      ...normalizeCampaignEmailParams(emailData.emailParams),
      richtextFields: mergeDesignRichtextFields(
        currentTemplate.params,
        emailData.emailParams?.richtextFields || {}
      )
    },
    emailData.globalParams,
    { brandLogoUrl: resolvedBrandLogoUrl }
  )

  const socialUrls = extractSocialMediaUrls(emailState.socialMediaLinks)
  const templateVariables = normalizeEmailFooterFields(
    buildEditorTemplateVariables(emailState, {
      brandLogoUrl: resolvedBrandLogoUrl || emailState.logoUrl,
      socialUrls
    })
  )
  const resolvedRichtextFields = mergeDesignRichtextFields(
    currentTemplate.params,
    emailState.richtextFields || {}
  )
  const socialTheme = resolveSocialFooterTheme(resolvedShellKey)

  const html = getHtmlFromMjml(
    currentTemplate.template,
    templateVariables,
    {
      ...buildRichtextHtmlMap(resolvedRichtextFields),
      socialMediaLinksHtml: generateSocialMediaLinksHtml(
        emailState.socialMediaLinks,
        socialTheme.theme,
        socialTheme.brandColor
      )
    },
    { templateKey: resolvedShellKey, brandLogoUrl: resolvedBrandLogoUrl || emailState.logoUrl }
  )

  return replaceTagsWithPreviewContent(extractPreviewBodyHtml(html), userName)
}
